import { mobiClient } from '@/services/axiosConfig'
import { DanValidateReq, DanValidateRes } from './types'

export const validate = async (req: DanValidateReq): Promise<DanValidateRes | undefined> => {
  try {
    const res = await mobiClient.post('/dan', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
